import { Provider as RenameProvider } from './rename/rename-context.jsx';
import { Provider as DeleteProvider } from './delete/delete-context.jsx';
import { Provider as PdfProvider } from './pdf/pdf-context.jsx';
import { Provider as ShapefileProvider } from './shapefile/shapefile-context.jsx';
import { Provider as FourRProvider } from './fourR/four-r-context.jsx';

export function ActionProviders(props) {
  return (
    <RenameProvider>
      <DeleteProvider>
        <PdfProvider>
          <ShapefileProvider>
            <FourRProvider>
              <>{props.children}</>
            </FourRProvider>
          </ShapefileProvider>
        </PdfProvider>
      </DeleteProvider>
    </RenameProvider>
  );
}
